import { DynamicTableFieldDTO, DynamicTableValueDTO } from './dynamic-table-dto';

export interface ContextRoleProfileDatasetFieldDTO extends DynamicTableFieldDTO {}

export interface ContextRoleProfileDatasetValueDTO extends DynamicTableValueDTO {}
